export const TestId = {
  LOADER_ID: 'loader-id'
};
